import { render, staticRenderFns } from "./RouteInfo.vue?vue&type=template&id=10fcf4ec&scoped=true&"
import script from "./RouteInfo.vue?vue&type=script&lang=js&"
export * from "./RouteInfo.vue?vue&type=script&lang=js&"
import style0 from "./RouteInfo.vue?vue&type=style&index=0&id=10fcf4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fcf4ec",
  null
  
)

export default component.exports